import React, { useState } from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const AddLeaguesModal = ({ show, handleClose }) => {
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Create League</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>League Name:</Form.Label>
                            <Form.Control type="text" name="leagueName" placeholder="Enter league name" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Country:</Form.Label>
                            <Form.Control type="text" name="country" placeholder="Enter country" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Season Start Date:</Form.Label>
                            <Form.Control type="date" name="seasonStartDate" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Season End Date:</Form.Label>
                            <Form.Control type="date" name="seasonEndDate" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>No of Teams:</Form.Label>
                            <Form.Control type="number" name="numberOfTeams" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Logo:</Form.Label>
                            <Form.Control type="file" name="logo" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Website:</Form.Label>
                            <Form.Control type="url" name="website" placeholder="Enter website URL" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Contact Email:</Form.Label>
                            <Form.Control type="email" name="contactEmail" placeholder="Enter contact email" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Contact Phone:</Form.Label>
                            <Form.Control type="tel" name="contactPhone" placeholder="Enter contact phone" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Description:</Form.Label>
                            <Form.Control as="textarea" rows={3} name="description" placeholder="Enter description" />
                        </Form.Group>
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AddLeaguesModal;